/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './style';
import {
  Icons
} from 'components';

const Overview = ({ products, consumeType, voucherType, targetUser , currencyText}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      item
      xs={12}
      className={classes.root}
    >
      <Grid item xs={12}>


        <li className={classes.headLine}>
          {'بن تخفیف '}
          {voucherType === 'percentage' ? 'درصدی' : 'مبلغی'}
          {' قابل استفاده بر روی '}
          {products && products?.length > 0 ? 'محصولات زیر' : 'همه محصولات'}
          {voucherType === 'percentage' ? (
            <>
              {' و به صورت '}
              {consumeType === 'DISPOSABLE_ITEM'
                ? 'یک بار اعمال روی یک قلم کالا/محصول (از یک فاکتور)'
                : null}
              {consumeType === 'DISPOSABLE_INVOICE'
                ? 'یک بار اعمال روی تمام اقلام/محصولات (از یک فاکتور)'
                : null}
              {consumeType === 'UNLIMITED' ? 'بدون محدودیت' : null}
              {'. '}
            </>
          ) : (
            ''
          )}
        </li>

        {products && products?.length > 0 ? (
          <>
            <li className={classes.listHeadLine}>
              <span className={classes.listHeadLineIcon} >
                <Icons icon='productList' color='#2B3990' size='18' />
              </span>
              محصولات:
            </li>

            {products.map((v, k) => (
              <li className={classes.usageItem}>
                {v?.id}. {v?.name}
              </li>
            ))}
          </>
        ) : null}
        {targetUser?.userId ? (
          <>
            <li className={classes.listHeadLine}>
              <span className={classes.listHeadLineIcon} >
                <Icons icon='user' color='#2B3990' size='18' />
              </span>
              کاربر مجاز به استفاده:
            </li>

            <li className={classes.usageItem}>
              {targetUser?.userId}. {targetUser?.fullName ?? targetUser?.username}
            </li>
          </>
        ) : null}


      </Grid>
    </Grid>
  );
};



export default Overview;
